import ExpressIcon from "@/assets/icons/express.svg?react";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

export const TypeEnvoi = ({ express }: { express: boolean }) => {
  const { t } = useTranslation("shared");
  if (express) {
    return (
      <Badge className="bg-brand600 hover:bg-brand600/90 gap-2 rounded-xl border-transparent px-3 py-1 text-sm font-medium text-white [&>svg]:h-6 [&>svg]:w-6">
        <ExpressIcon />
        {t("shippingTypeBadge.express")}
      </Badge>
    );
  }
  return (
    <Badge className="rounded-xl border-transparent bg-gray-500 px-3 py-1 text-sm font-medium text-white hover:bg-gray-500/90">
      {t("shippingTypeBadge.standard")}
    </Badge>
  );
};
